import axios from 'axios';

(() => {
  document.addEventListener('click', (e) => {
    const el = e.target.closest('a.is-download[href*="/account/download?id="]');

    if (!el) {
      return;
    }

    const href = el.href;

    el.classList.add('is-downloading');

    axios({
      method: 'GET',
      url: href,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(res => {
        el.classList.remove('is-downloading');

        let url = res.data.url;

        const measuredServerspeeds = JSON.parse(window.localStorage.getItem('swinger.serverspeeds') || '{}');
        const measuredServers = Object.keys(measuredServerspeeds);

        if (
          measuredServers.length &&
          res.data.alternativeUrls &&
          res.data.alternativeUrls.length
        ) {
          const combinedUrls = [res.data.url].concat(res.data.alternativeUrls);

          const cdnUrls = combinedUrls.filter(url => {
            return url.indexOf('c77-') > -1;
          });

          if (cdnUrls.length) {
            url = cdnUrls[0];
          } else {
            const matchingServers = measuredServers.filter(server => {
              const hostname = `${server}.dvdl.net`;

              return combinedUrls.join(',').indexOf(hostname) > -1;
            });

            if (matchingServers.length) {
              const fastestMatchingServer = matchingServers.sort((a, b) => {
                return measuredServerspeeds[b] - measuredServerspeeds[a];
              })[0];

              url = combinedUrls
                .reduce((fastestUrl, url) => {
                  if (url.indexOf(`${fastestMatchingServer}.dvdl.net`) > -1) {
                    fastestUrl = url;
                  }

                  return fastestUrl;
                }, url);

              // eslint-disable-next-line no-console
              console.info('Possible download URLs: ', combinedUrls);
              // eslint-disable-next-line no-console
              console.info(`Fastest download URL: ${url}`);
            }
          }
        }

        window._paq = window._paq || [];
        window._paq.push([
          'trackEvent',
          'Download',
          `Quality: ${el.textContent.replace('Download ', '').trim()}`,
          href.replace(/^[\d\D]+id=(\d+)$/, '$1'),
          url
        ]);

        window.location = url;
      });

    e.preventDefault();
  });
})();
